import Phaser from 'phaser'

class Missile extends Phaser.GameObjects.Image {
    constructor(scene, frame) {
        super(scene, 0, 0, frame)

        this.scaleX = 0.12
        this.scaleY = 0.08
    }
}

export default Missile
